/* lalzz.store — theme script
   Uses Shopify's real /cart/add.js and /cart.js. No SPA routing. */

(function () {
  'use strict';

  var CART_URL_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      try { return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat); } catch (e) {}
    }
    return '₹' + (cents / 100).toFixed(0);
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Scroll animations ─────────────────────────────────── */
    var revealObserver;
    function triggerReveals() {
      if (revealObserver) revealObserver.disconnect();
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    /* ── Hero word stagger ─────────────────────────────────── */
    document.querySelectorAll('.hero h1 .word').forEach(function (w, i) {
      w.style.animationDelay = (120 + i * 90) + 'ms';
    });

    /* ── Scroll progress rail + sticky header ──────────────── */
    var fill = document.getElementById('scroll-fill');
    var header = document.getElementById('header');
    var rafPending = false;
    window.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        if (fill) {
          var h = document.documentElement;
          var pct = h.scrollTop / (h.scrollHeight - h.clientHeight);
          fill.style.width = (pct * 100) + '%';
        }
        if (header) header.classList.toggle('is-scrolled', window.scrollY > 20);
        rafPending = false;
      });
    }, { passive: true });

    /* ── Theme toggle (persists) ───────────────────────────── */
    var themeBtn = document.getElementById('theme-toggle');
    if (themeBtn) {
      themeBtn.addEventListener('click', function () {
        var current = document.documentElement.getAttribute('data-theme') || 'light';
        var next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try { localStorage.setItem('lalzz-theme', next); } catch (e) {}
      });
    }

    /* ── Mobile menu ───────────────────────────────────────── */
    var menuBtn = document.getElementById('menu-btn');
    var mobileNav = document.getElementById('mobile-nav');
    if (menuBtn && mobileNav) {
      menuBtn.addEventListener('click', function () {
        var isOpen = mobileNav.classList.toggle('is-open');
        menuBtn.setAttribute('aria-expanded', String(isOpen));
        mobileNav.hidden = !isOpen;
      });
      mobileNav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          mobileNav.classList.remove('is-open');
          menuBtn.setAttribute('aria-expanded', 'false');
          mobileNav.hidden = true;
        });
      });
    }

    /* ── Quantity selector + live total ────────────────────── */
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus  = document.getElementById('qty-plus');
    var qtyVal   = document.getElementById('qty-val');
    var qtyHidden = document.getElementById('qty-hidden');
    var liveTotalEl = document.getElementById('live-total');
    var btnTotalEl  = document.querySelector('[data-btn-total]');
    var addToCartBtn = document.querySelector('.hero__actions [data-add-to-cart]');

    function formatINR(cents) {
      // Try Shopify's money formatter first (best — respects shop's format)
      if (window.Shopify && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
        try { return Shopify.formatMoney(cents, window.theme.moneyFormat); } catch (e) {}
      }
      // Fallback: format as ₹X.YY with Indian grouping
      var rupees = (cents / 100);
      var s = rupees.toFixed(2);
      var parts = s.split('.');
      var intPart = parts[0];
      var lastThree = intPart.slice(-3);
      var rest = intPart.slice(0, -3);
      if (rest) lastThree = ',' + lastThree;
      var grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
      return 'Rs. ' + grouped + '.' + parts[1];
    }

    function updateLiveTotal() {
      if (!qtyVal) return;
      var qty = parseInt(qtyVal.textContent, 10) || 1;
      // Read unit price from whichever element has it
      var unit = null;
      if (liveTotalEl && liveTotalEl.dataset.unitPriceCents) {
        unit = parseInt(liveTotalEl.dataset.unitPriceCents, 10);
      } else if (addToCartBtn && addToCartBtn.dataset.unitPriceCents) {
        unit = parseInt(addToCartBtn.dataset.unitPriceCents, 10);
      }
      if (unit === null || isNaN(unit)) return;
      var totalStr = formatINR(unit * qty);
      if (liveTotalEl) liveTotalEl.textContent = totalStr;
      if (btnTotalEl)  btnTotalEl.textContent  = totalStr;

      // Brief pulse on the total chip so the change registers visually
      var chip = document.querySelector('.live-total');
      if (chip) {
        chip.classList.add('is-updated');
        setTimeout(function () { chip.classList.remove('is-updated'); }, 260);
      }
    }

    function updateQtyHidden() { if (qtyHidden && qtyVal) qtyHidden.value = qtyVal.textContent; }

    if (qtyMinus && qtyVal) qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyVal.textContent, 10) || 1;
      if (v > 1) { qtyVal.textContent = v - 1; updateQtyHidden(); updateLiveTotal(); }
    });
    if (qtyPlus && qtyVal) qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyVal.textContent, 10) || 1;
      if (v < 10) { qtyVal.textContent = v + 1; updateQtyHidden(); updateLiveTotal(); }
    });
    // Initialize once on load
    updateLiveTotal();

    /* ── Cart-page quantity steppers ───────────────────────── */
    document.querySelectorAll('.cart-qty').forEach(function (wrap) {
      var input = wrap.querySelector('.cart-qty__val');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-delta]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-qty-delta'), 10) || 0;
          var v = (parseInt(input.value, 10) || 0) + delta;
          if (v < 0) v = 0;
          if (v > 99) v = 99;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ── Gallery thumbs (product page) ─────────────────────── */
    document.querySelectorAll('#gallery-thumbs .thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('#gallery-thumbs .thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-src');
        var main = document.getElementById('prod-main-img');
        if (main && src) {
          main.style.opacity = '0';
          setTimeout(function () { main.src = src; main.style.opacity = '1'; }, 180);
        }
      });
    });

    /* ── Reviews carousel ──────────────────────────────────── */
    var rt = document.getElementById('reviews-track');
    var prevBtn = document.getElementById('rev-prev');
    var nextBtn = document.getElementById('rev-next');
    function scrollReviews(dir) {
      if (!rt) return;
      var card = rt.querySelector('.review-card');
      var w = card ? card.offsetWidth + 20 : 360;
      rt.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollReviews(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollReviews(1); });

    /* ── FAQ accordion (native <details>) — enhance ─────────── */
    // Nothing needed — <details> handles it. Just ensure only one open at a time (optional):
    document.querySelectorAll('.faq-list').forEach(function (list) {
      var items = list.querySelectorAll('.faq-item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) {
            items.forEach(function (other) { if (other !== item) other.open = false; });
          }
        });
      });
    });

    /* ── Cart integration — real /cart/add.js ──────────────── */

    function updateCartCount() {
      fetch(CART_URL_ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-visible', cart.item_count > 0);
          });
        })
        .catch(function () { /* silent */ });
    }

    // Intercept product form submits — but ONLY for our own "Add to cart" button.
    // Shopify's dynamic checkout (Buy Now) button must pass through untouched.
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // e.submitter tells us which button triggered the submit.
        // If it's not our add-to-cart button, let the browser/Shopify handle it.
        var submitter = e.submitter;
        if (submitter && !submitter.hasAttribute('data-add-to-cart')) return;
        // Extra guard: never intercept anything inside the dynamic-checkout wrapper.
        if (submitter && submitter.closest('.shopify-payment-button')) return;

        e.preventDefault();
        var button = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
        var originalHTML = button ? button.innerHTML : '';
        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
        }

        var fd = new FormData(form);
        fetch(CART_URL_ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            if (button) {
              button.classList.remove('is-loading');
              button.classList.add('added');
              button.innerHTML = '<span>✓ Added!</span>';
            }
            var badge = document.getElementById('cart-badge');
            if (badge) {
              badge.classList.add('is-pop');
              setTimeout(function () { badge.classList.remove('is-pop'); }, 500);
            }
            updateCartCount();
            if (button) flyToCart(button);
            setTimeout(function () {
              if (button) {
                button.classList.remove('added');
                button.innerHTML = originalHTML;
                button.disabled = false;
              }
            }, 1600);
          })
          .catch(function () {
            if (button) {
              button.disabled = false;
              button.classList.remove('is-loading');
              button.innerHTML = originalHTML;
            }
            window.location.href = CART_URL_ROOT + 'cart';
          });
      });
    });

    /* ── Fly-to-cart particle burst ────────────────────────── */
    function flyToCart(btn) {
      var cartBtn = document.getElementById('cart-btn');
      if (!cartBtn) return;
      var s = btn.getBoundingClientRect();
      var d = cartBtn.getBoundingClientRect();
      var colors = ['#ff2e6e', '#2ecc71', '#ffb028', '#c81b58', '#4ac4e8'];
      for (var i = 0; i < 8; i++) {
        (function (idx) {
          var dot = document.createElement('span');
          dot.style.cssText = 'position:fixed;width:12px;height:12px;border-radius:50%;background:' + colors[idx % colors.length] +
            ';z-index:9999;pointer-events:none;box-shadow:0 0 16px ' + colors[idx % colors.length];
          var sx = s.left + s.width / 2;
          var sy = s.top + s.height / 2;
          var dx = d.left + d.width / 2;
          var dy = d.top + d.height / 2;
          dot.style.left = sx + 'px';
          dot.style.top = sy + 'px';
          document.body.appendChild(dot);
          var name = 'fly-' + Math.random().toString(36).slice(2);
          var wobble = (Math.random() - 0.5) * 240;
          var style = document.createElement('style');
          style.textContent = '@keyframes ' + name + '{' +
            '0%{left:' + sx + 'px;top:' + sy + 'px;transform:scale(1);opacity:1}' +
            '50%{left:' + (sx + (dx - sx) * 0.5 + wobble) + 'px;top:' + (sy - 100 - idx * 6) + 'px;transform:scale(1.5);opacity:.95}' +
            '100%{left:' + dx + 'px;top:' + dy + 'px;transform:scale(.2);opacity:0}' +
            '}';
          document.head.appendChild(style);
          dot.style.animation = name + ' ' + (750 + idx * 40) + 'ms cubic-bezier(.5,.05,.2,1) forwards';
          setTimeout(function () { dot.remove(); style.remove(); }, 950);
        })(i);
      }
    }

    /* ── Live purchase toasts (social proof) ───────────────── */
    // Only render a toast host if one doesn't already exist
    var toastHost = document.getElementById('social-toast');
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'toast';
      toastHost.id = 'social-toast';
      toastHost.innerHTML =
        '<div class="toast__avatar" id="toast-avatar">PS</div>' +
        '<div class="toast__body" id="toast-body"></div>';
      document.body.appendChild(toastHost);
    }
    var toastAvatar = document.getElementById('toast-avatar');
    var toastBody   = document.getElementById('toast-body');
    var toastData = [
      { name: 'Priya S.', location: 'Mumbai',    initials: 'PS', color: '#ff2e6e' },
      { name: 'Rahul K.', location: 'Bengaluru', initials: 'RK', color: '#2ecc71' },
      { name: 'Ananya N.',location: 'Delhi',     initials: 'AN', color: '#ffb028' },
      { name: 'Vikram S.',location: 'Pune',      initials: 'VS', color: '#c81b58' },
      { name: 'Divya P.', location: 'Ahmedabad', initials: 'DP', color: '#1a9550' },
      { name: 'Arjun M.', location: 'Chennai',   initials: 'AM', color: '#ff2e6e' },
      { name: 'Meera I.', location: 'Kochi',     initials: 'MI', color: '#2ecc71' },
      { name: 'Karan J.', location: 'Hyderabad', initials: 'KJ', color: '#ffb028' }
    ];
    var toastIdx = 0;
    function showToast() {
      var data = toastData[toastIdx % toastData.length];
      if (toastAvatar) {
        toastAvatar.textContent = data.initials;
        toastAvatar.style.background = data.color;
      }
      var t = (Math.floor(Math.random() * 15 + 2)) + ' minutes ago';
      if (toastBody) {
        toastBody.innerHTML = '<strong>' + data.name + '</strong> from ' + data.location + ' just bought a Fresh Juice<span>' + t + '</span>';
      }
      toastHost.classList.add('is-visible');
      setTimeout(function () { toastHost.classList.remove('is-visible'); }, 3800);
      toastIdx++;
    }
    if (!document.body.classList.contains('template-cart') && !document.body.classList.contains('template-checkout')) {
      setTimeout(function () { showToast(); setInterval(showToast, 22000); }, 8000);
    }

    /* ── Init ──────────────────────────────────────────────── */
    triggerReveals();
    updateCartCount();
  });
})();
